<template>
  <v-container fluid class="pa-0">
    <v-card class="mb-4" v-if="currentModel != null" height="500px">
      <v-toolbar card color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title >{{$t('inGame.supplychainGraph')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
        <v-card-text style="height:450px">
          <vis :companies="currentModel.companies"/>
        </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import Vis from './Vis'
export default {
  name: "GameVersionStyle",
  components: {
    Vis
  },
  data() {
    return {
      currentModel: null
    };
  },
  mounted() {
    this.getModel();
  },
  methods: {
    async getModel() {
      let model = await this.$store.dispatch(
        "gameVersions/getOne",
        this.$route.params.id
      );
      this.currentModel = Object.assign({}, model);
    }
  }
};
</script>
